import React from 'react';

const Header = () => {
    return (
        <header>
            <a href="/" className="logo">   
                <h1>JR</h1>
            </a>
           
            <nav>
                <ul>
                    {/* <li><a href="/">Home</a></li> */}
                    {/* <li><a href="/about">About</a></li>
                    <li><a href="/projects">Projects</a></li>*/}
                    <li><a href="/contact">Contact</a></li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;